import React from "react"
import { connect } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close';
import { setSnackBar } from '../../models/application/applicationActions'
import { Box, Button, Dialog } from '@mui/material'
import { useHistory } from "react-router";

const CampaignBannerDialog = (props) => {
    const {
        onCloseDialog,
        campaignBanner,
        translations,
        app
    } = props
    const history = useHistory()

    return <Dialog
        maxWidth='md'
        style={{
            padding: 0, minWidth: 
            window.innerWidth > 1200 ? 1200 : '100%',
            overflow: 'hidden'
        }}
        open={props.open}
        onClose={onCloseDialog}
        aria-labelledby="form-dialog-title" >
        <div style={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer', zIndex: 100 }} onClick={() => {
            
            onCloseDialog(false)
        }}>
            <CloseIcon />
        </div>
        <Button
            onClick={() => {
                onCloseDialog(false)
                history.push(campaignBanner.link)
            }}
            sx={[{
                position: 'absolute',
                zIndex: 10,
                bottom: 10,
                width: 160,
                right: 10,
                '&:hover': {
                    color: 'white',
                    backgroundColor: 'black',
                },
            }, { backgroundColor: 'black', color: 'white', }]}>{translations?.see_details}</Button>
        <Box sx={{
            cursor: 'pointer',
            padding: 0,
            width: window.innerWidth > 1200 ? 800 : window.innerWidth - 32,
            marginTop: 0,
            height: window.innerWidth > 1200 ? 480 : 'auto',
            display: 'flex',
            overflow: 'hidden',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }} onClick={() => {
            onCloseDialog(false)
            history.push(campaignBanner.link)

        }}>
            <img src={window.innerWidth > 1000 ? campaignBanner?.image: campaignBanner?.imageMobile} />
        </Box>
    </Dialog>
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.auth,
        app: state.app,
        translations: state.translations,
    }
}

export default connect(mapStateToProps, { setSnackBar })(CampaignBannerDialog)